import * as actionCreatorFactory from "typescript-fsa";
import { Action } from "typescript-fsa";

import { HttpStateError, NormalisedResult } from "@orm/models";
import { LocalisationNormalisedEntities } from "../models";
import * as actionTypes from "../constants";

const actionCreator = actionCreatorFactory.default();

const languageChange = actionCreator<string>(actionTypes.LANGUAGE_CHANGE);

// Countries
export const requestCountriesIndex = actionCreator<{}>(actionTypes.COUNTRY_INDEX_REQUEST);
export const countriesIndexSuccess = actionCreator<NormalisedResult<string[], LocalisationNormalisedEntities>>(
    actionTypes.COUNTRY_INDEX_SUCCESS,
);
export const countriesIndexFailure = actionCreator<HttpStateError>(actionTypes.COUNTRY_INDEX_FAILURE);

type LocalisationAction = Action<string> | Action<{}> | Action<HttpStateError> |
    Action<NormalisedResult<string[], LocalisationNormalisedEntities>>;

export {
    LocalisationAction,
    languageChange,
};
